import MiqdorInput from "../../Component/Tables/ModalTable/KirimChiqimInputs/MiqdorInput";
import { RiStackFill } from "react-icons/ri";
import {
  DATE,
  MODALTABLE,
  STRING,
} from "../../Component/Modals/ModalComponents/ModalInputTypes";
import { SIMPLE } from "../../Component/Sidebar/PageTypes";
import DocumentClass from "../../Functions/DocumentClass";
import NumberFormat from "../../Functions/NumberFormat";
import moment from "moment";
import MiqdorSelect from "../../Component/Tables/ModalTable/KirimChiqimInputs/MiqdorSelect";
import ShowAllBtn from "./Components/ShowAllBtn";
import SanaFormat from "../../Functions/SanaFormat";
const YukBeruvchilarQoldigi = {
  title: "Юк берувчилар қолдиғи",
  path: "/yukBeruvchilar-qoldigi",
  type: SIMPLE,
  icon: <RiStackFill></RiStackFill>,
  allData: [{ value: "yuk_beruvchi_id", prop: "yuk_beruvchilar", get: "fio" }],
  defaultValues: [
    {
      prop: "turi",
      value: 1,
    },
  ],
  modalJami: "yukberuvchi-qoldigi",
  innerData: "yuk_beruvchilar",
  columns: [
    {
      title: <div className="table_head">№</div>,
      key: "index",
      render: (text, record, index) => index + 1,
      width: "50px",
      align: "center",
    },
    {
      title: <div className="table_head">ID</div>,
      dataIndex: "Id",
      width: "100px",
      align: "center",
    },
    {
      title: <div className="table_head">Сана</div>,
      dataIndex: "time_create",
      key: "nomi",
      width: "150px",
      render: (text) => SanaFormat(text),
    },
    {
      title: <div className="table_head">Изох</div>,
      dataIndex: "izoh",
      key: "nomi",
      width: "178px",
    },
    {
      title: <div className="table_head">Қарзингиз</div>,
      children: [
        {
          title: <div className="table_head">Сўм</div>,
          dataIndex: "document",
          key: "nomi",
          width: "150px",
          align: "right",
          render: (text) =>
            NumberFormat(DocumentClass(text, "yukberuvchi-qoldigi").debit_som),
        },
        {
          title: <div className="table_head">Валюта</div>,
          dataIndex: "document",
          key: "nomi",
          width: "150px",
          align: "right",
          render: (text) =>
            NumberFormat(
              DocumentClass(text, "yukberuvchi-qoldigi").debit_val,
              1
            ) + " $",
        },
      ],
    },
    {
      title: <div className="table_head">Хаққингиз</div>,
      children: [
        {
          title: <div className="table_head">Сўм</div>,
          dataIndex: "document",
          key: "nomi",
          width: "150px",
          align: "right",
          render: (text) =>
            NumberFormat(DocumentClass(text, "yukberuvchi-qoldigi").kredit_som),
        },
        {
          title: <div className="table_head">Валюта</div>,
          dataIndex: "document",
          key: "nomi",
          width: "150px",
          align: "right",
          render: (text) =>
            NumberFormat(
              DocumentClass(text, "yukberuvchi-qoldigi").kredit_val,
              1
            ) + " $",
        },
      ],
    },
  ],
  forms: [
    {
      type: "document",
      grid: "1fr",
      actionInputs: [
        {
          grid: "2fr 4fr",
          inputs: [
            {
              label: "Сана",
              name: "time_create",
              type: DATE,
            },
            {
              label: "Изох",
              name: "izoh",
              type: STRING,
            },
          ],
        },
      ],
      inputs: [
        {
          name: "document",
          type: MODALTABLE,
          innerModal: {
            title: "Юк берувчилар",
            columns: [
              {
                title: <div className="table_head">№</div>,
                key: "index",
                render: (text, record, index) => index + 1,
                width: "50px",
                align: "center",
              },
              {
                title: <div className="table_head">Номи</div>,
                dataIndex: "fio",
                key: "nomi",
              },
            ],
          },

          costumColumns: [
            {
              title: <div className="table_head">№</div>,
              key: "index",
              render: (text, record, index) => index + 1,
              width: "70px",
              align: "center",
            },
            {
              title: <div className="table_head">Юк берувчи</div>,
              dataIndex: "element_id",
              key: "nomi",
              render: (text) => (
                <div style={{ display: "flex", alignItems: "flex-end" }}>
                  <MiqdorSelect
                    name={"element_id"}
                    value={text}
                    placeholder="Юк берувчи"
                    get="fio"
                    allDataType={"yuk_beruvchilar"}
                  ></MiqdorSelect>
                  <ShowAllBtn></ShowAllBtn>
                </div>
              ),
            },
            {
              title: <div className="table_head">Қарзингиз</div>,
              children: [
                {
                  title: <div className="table_head">Сўм</div>,
                  dataIndex: "debit_som",
                  key: "nomi",
                  render: (text) => (
                    <MiqdorInput name="debit_som" value={text}></MiqdorInput>
                  ),
                  width: "200px",
                },
                {
                  title: <div className="table_head">Валюта</div>,
                  dataIndex: "debit_val",
                  key: "nomi",
                  render: (text) => (
                    <MiqdorInput name="debit_val" value={text}></MiqdorInput>
                  ),
                  width: "120px",
                },
              ],
            },
            {
              title: <div className="table_head">Хаққингиз</div>,
              children: [
                {
                  title: <div className="table_head">Сўм</div>,
                  dataIndex: "kredit_som",
                  key: "nomi",
                  render: (text) => (
                    <MiqdorInput name="kredit_som" value={text}></MiqdorInput>
                  ),
                  width: "200px",
                },

                {
                  title: <div className="table_head">Валюта</div>,
                  dataIndex: "kredit_val",
                  key: "nomi",
                  render: (text) => (
                    <MiqdorInput name="kredit_val" value={text}></MiqdorInput>
                  ),
                  width: "120px",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default YukBeruvchilarQoldigi;
